import "./Registry.css"
import "../login/Login.css"
import Expiration from "../expiration"
import Icon from "src/shared/icons"
import { Button } from "src/shared/components/forms"
import { useNavigate, useSearchParams } from "react-router-dom"

function Verified(): JSX.Element {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const status = searchParams.get("status")
    const isVerified = status === "success"

    return isVerified ? (
            <div className="registry-screen">
                <div className="verification-screen_content">
                    <div className="verified-screen_header">
                        <Icon name="mailVerify" color="#6941C6" width={60} height={60} />
                    </div>
                    <p className="registry-screen_title">Tu cuenta ha sido verificada</p>
                    <p className="verified-screen_text">
                    Hemos verificado tu correo exitosamente, tu cuenta esta activa y desde este momento ya puedes
                    empezar a usarla.
                    </p>
                    <Button
                        className="verification-screen_button"
                        theme="primary"
                        text="Iniciar sesión"
                        onClick={() => navigate("/")}
                    />
                </div>
            </div>
        ) : (
            <Expiration />
        )
}

export default Verified
